import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert, X } from "lucide-react";
import { useAuth } from "../lib/auth";
import api from "../lib/api";

const SENSITIVE_ROLES = ["corporate_admin", "treasury"];
const DISMISS_KEY = "chizy_2fa_banner_dismissed";

export default function SecurityBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");
  const [mandatory, setMandatory] = useState(false);

  useEffect(() => {
    if (!user || !SENSITIVE_ROLES.includes(user.role) || user.two_fa_enabled) return;
    api.get("/auth/me").then((r) => setMandatory(!!r.data.two_fa_mandatory)).catch(() => {});
  }, [user]);

  if (!user || dismissed) return null;
  if (!SENSITIVE_ROLES.includes(user.role)) return null;
  if (user.two_fa_enabled) return null;
  if (mandatory) return null; // ya se le fuerza 2FA por política, no hace falta "invitarlo"

  return (
    <div
      data-testid="security-2fa-banner"
      className="bg-amber-50 border-b border-amber-200 px-6 py-2.5 flex items-center gap-3"
    >
      <ShieldAlert className="w-4 h-4 text-amber-700 flex-shrink-0" />
      <p className="text-sm text-amber-900 flex-1 min-w-0">{t("security.banner.text")}</p>
      <button
        data-testid="security-banner-cta"
        onClick={() => navigate("/perfil/seguridad")}
        className="text-sm font-bold text-amber-900 underline decoration-amber-400 underline-offset-2 hover:decoration-2 whitespace-nowrap"
      >
        {t("security.banner.cta")}
      </button>
      <button
        data-testid="security-banner-dismiss"
        onClick={() => { sessionStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); }}
        className="text-amber-700 hover:text-amber-900 p-1"
        aria-label={t("common.close")}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
